export const juices = [
  {
    id: 1,
    name: 'Energía Verde',
    description: 'Espinaca, manzana, pepino y limón para cargar energías',
    price: 5.99,
    category: 'verdes',
    emoji: '🥬'
  },
  {
    id: 2,
    name: 'Tropical Bliss',
    description: 'Mezcla exótica de mango, piña y coco',
    price: 6.49,
    category: 'tropicales',
    emoji: '🏝️'
  },
  {
    id: 3,
    name: 'Berry Power',
    description: 'Antioxidante mezcla de frutos rojos con yogurt',
    price: 6.99,
    category: 'cremosos',
    emoji: '🫐'
  },
  {
    id: 4,
    name: 'Citrus Splash',
    description: 'Naranja, zanahoria y jengibre para tu sistema inmune',
    price: 5.49,
    category: 'citricos',
    emoji: '🍊'
  },
  {
    id: 5,
    name: 'Detox Master',
    description: 'Remolacha, apio, jengibre y limón para limpiar tu cuerpo',
    price: 6.29,
    category: 'verdes',
    emoji: '🧪'
  },
  {
    id: 6,
    name: 'Sunny Delight',
    description: 'Zanahoria, naranja y cúrcuma para brillar como el sol',
    price: 5.79,
    category: 'citricos',
    emoji: '☀️'
  }
];

export const categories = [
  { name: 'verdes', description: 'Jugos verdes (espinaca, pepino, etc.)' },
  { name: 'tropicales', description: 'Sabores tropicales (mango, piña, coco)' },
  { name: 'cremosos', description: 'Cremosos con yogurt y frutas' },
  { name: 'citricos', description: 'Cítricos y vitaminas (naranja, limón)' }
];

// initialOrders puede comenzar vacío. Si quieres ejemplos, los podemos añadir luego.
export const initialOrders = [];